import { endOfDay, isAfter } from 'date-fns';
import { Col } from '../../col';
import { RadarLineIcon, TimeLineIcon } from '../../icons';
import { Row } from '../../row';
import { Tag } from '../../tag';
import { Text } from '../../typography';
import type { TagMode } from '../WidgetItem';
import { type FormattedTimeConfig, WidgetItemTimeText } from './widget-item-time-text';

type P = {
  activeDate: Date;
  alwaysShowTimeTag?: boolean;
  tags?: TagMode[];
  timeConfig: FormattedTimeConfig;
};

const WidgetItemTimeTag = ({ activeDate, alwaysShowTimeTag = false, tags, timeConfig }: P) => {
  const shouldSkipTimeTag = alwaysShowTimeTag
    ? false
    : timeConfig.options.display === 'hidden' ||
      (timeConfig.options.display === 'time' && isAfter(timeConfig.time, endOfDay(activeDate)));

  if (shouldSkipTimeTag) {
    return null;
  }

  const isLive = tags?.includes('live');

  return (
    <Row gutter="xs">
      {isLive ? (
        <Col>
          <Tag color="live" format={{ upperCase: true }} icon={<RadarLineIcon />} iconNoneMargin size="extra-small">
            time_tag_live
          </Tag>
        </Col>
      ) : null}
      <Col>
        <Text size="small">
          <TimeLineIcon />
          <WidgetItemTimeText timeConfig={timeConfig} />
        </Text>
      </Col>
    </Row>
  );
};

export default WidgetItemTimeTag;
